import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=1ae62c24&scoped=true"
import script from "./Rate.vue?vue&type=script&lang=js"
export * from "./Rate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae62c24",
  null
  
)

export default component.exports